const parseMenuTree = (menuList) => {
  let menuTree = [];
  let menuIdMap = {};
  let menuUrlMap = {};
  let actionPermissionMap = {};
  menuList.forEach(t => {
    menuIdMap[t.id] = t;
    if (t.menuUrl) {
      if (menuUrlMap[t.menuUrl]) {
        menuUrlMap[t.menuUrl].push(t);
      } else {
        menuUrlMap[t.menuUrl] = [t];
      }
    }

    if (t.type === '1') {
      // 菜单资源重新设置对应的URL
      Object.defineProperty(t, 'url', {
        get () {
          if (t.menuUrl) {
            return t.menuUrl;
          }
          if (t.children && t.children[0]) {
            return t.children[0].url;
          }
          return t.id;
        },
      });
    } else {
      // 操作按钮资源
      actionPermissionMap[t.permissionCode] = true;
    }
  });
  menuList.forEach(t => {
    // 处理根节点
    if (t.type === '1') {
      if (t.level === 1) {
        if (!t.children) {
          t.children = [];
        }
        menuTree.push(t);
      } else {
        // 处理其他节点
        // 判断父节点是否有children，若没有，则初始化
        // 若有则，直接在父节点的children中插入
        if (t.parentId && menuIdMap[t.parentId]) {
          if (!menuIdMap[t.parentId].children) {
            menuIdMap[t.parentId].children = [];
          }
          let index = menuIdMap[t.parentId].children.findIndex(c => c.sort >= t.sort);
          if (index < 0) {
            menuIdMap[t.parentId].children.push(t);
          } else {
            menuIdMap[t.parentId].children.splice(index, 0, t);
          }
        }
      }
    }
  });
  return {menuTree, menuIdMap, menuUrlMap, actionPermissionMap};
};

const flattenTree = (menuList, treeMap, flattenList) => {
  treeMap = treeMap || {};
  flattenList = flattenList || [];
  menuList.forEach(t => {
    if (!treeMap[t.id]) {
      treeMap[t.id] = t;
      flattenList.push(t);
      if (t.children) {
        flattenTree(t.children, treeMap, flattenList);
      }
    }
  });
  return { treeMap, flattenList };
};

export { parseMenuTree, flattenTree };
